import { ITranslations } from 'types/common';
import { PointTransFields } from './types';
import en from 'translations/en/point.json';
import pl from 'translations/pl/point.json';
import sl from 'translations/sl/point.json';

export const pointTranslations: ITranslations<PointTransFields> = {
  name: 'point',
  en,
  pl,
  sl,
};
